'use strict';

/*
  ProductSwitcher

  Handles the switching of the offers UI on DashboardPreapproval.  Determines which offers to show and compare to.
  
  The product switcher compares an enhance offer to a previous offer. (NOT an expired one)
  A previous offer is an _active_ offer that is next inline with an earlier expiry date.
*/

function ProductSwitcher() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this._cantSeePreviousOffer = false;
  this.enhanced = null;

  this.init = function () {
    this.$node = $(this.node);
  };

  this.initAllReady = function () {
    var _this = this;

    this._activeOfferObj = new Offer(this.presenter, 'active');
    this._previousOfferObj = new Offer(this.presenter, 'previous');
    this._setupEnhancedState();
    this._setupProductSwitcher();
    this.$node.show();
    // run after page finishes being faded in.
    setTimeout(
    // @TODO
    function () {
      _this.productSwitchertoggleEnhanced();
    }, 400);
  };

  this._setupEnhancedState = function () {
    if (this._activeOfferObj.getOfferType() == 'enhanced' && !this._previousOfferObj.getOfferData()) {
      this._cantSeePreviousOffer = true;
      $('.product-switcher__wrapper-call-to-action').remove();
    }
  };

  // Product Switcher:
  this._setupProductSwitcher = function () {
    this.$productSwitcher = this.$node.find('.product-switcher');
    this.$loanCtas = $('.js--get-loan-cta');

    if (this._activeOfferObj.getOfferType() == 'enhanced') {
      // match initial disabled state on enhanced
      this.disableLoanCTAs();

      // remove legal disclaimers from previous offer:
      this.$productSwitcher.find('.product-switcher__default-view').find('[data-legal]').removeAttr('data-legal');

      // set switcher to enhanced mode
      this.$productSwitcher.addClass('product-switcher--enhanced');

      // set previous offers as expired
      this.$productSwitcher.find('.product-switcher__default-view .product-card').addClass('product-card--expired');

      // add events to switcher buttons
      this.$node.find('.product-switcher__call-to-action').on('click.showEnhanced', this.productSwitchertoggleEnhanced);
    }
  }.bind(this);

  this.productSwitchertoggleEnhanced = function (e) {
    if (arguments.length > 0) e.preventDefault();

    if (this._activeOfferObj.getOfferType() == 'enhanced') {
      // quicky and dirty hack for previously declined customers 3/3
      if (this._cantSeePreviousOffer) {
        $('.product-switcher__alt-view').css({
          'clip-path': 'none',
          '-webkit-clip-path': 'none',
          'z-index': 3
        });
        this.enableLoanCTAs();
        return false;
      }

      if (this.$productSwitcher.hasClass('product-switcher--alt-view')) {
        this.$productSwitcher.removeClass('product-switcher--alt-view');
        this.disableLoanCTAs();
        this._updateDisplayedOfferModel(true);
      } else {
        this.$productSwitcher.addClass('product-switcher--alt-view');
        this.enableLoanCTAs();
        this._updateDisplayedOfferModel(false);
      }
    }
  }.bind(this);

  this.disableLoanCTAs = function () {
    $.each(this.$loanCtas, function (index, elem) {
      $(elem).addClass('disabled');
      if ($(elem).mogo() && $(elem).mogo().declaredClass) {
        $(elem).mogo().setDisabledState();
      }
      $(elem).attr('data-history-disabled', true);
    });
  };

  this.enableLoanCTAs = function () {
    $.each(this.$loanCtas, function (index, elem) {
      $(elem).removeClass('disabled');
      if ($(elem).mogo() && $(elem).mogo().declaredClass) {
        $(elem).mogo().removeDisabledState();
      }
      $(elem).removeAttr('data-history-disabled');
    });
  };

  this._updateDisplayedOfferModel = function (showExpiredOffer) {
    var data = null;
    if (showExpiredOffer) {
      data = this._previousOfferObj.getOfferData();
      if (data) {
        data.isExpiredOffer = true;
      }
      this.presenter.updateModel('money.displayed_offer', [data]);
    } else {
      data = this._activeOfferObj.getOfferData();
      if (data) {
        data.isExpiredOffer = false;
      }
      this.presenter.updateModel('money.displayed_offer', [data]);
    }
    this.presenter.updateDOM();
  };

  this.destroy = function () {};
}